var exports = {
  "Qr": "MarkdownTab.module__sectionsContainer___d005SE",
  "uW": "MarkdownTab.module__section___d005SE",
  "bV": "MarkdownTab.module__sectionHeader___d005SE",
  "AS": "MarkdownTab.module__item___d005SE",
  "Li": "MarkdownTab.module__itemHeader___d005SE",
  "IR": "MarkdownTab.module__itemLabel___d005SE",
};

module.exports = exports;
